import { render } from "./physical-links-button.vue?vue&type=template&id=fc333556"
import script from "./physical-links-button.vue?vue&type=script&lang=js"
export * from "./physical-links-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__